// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3BT4Y","loader":"App_loader__RWn0r"};